export interface TruncateStringProps {
  str: string;
  number?: number;
}
export function truncateString({ str, number = 50 }: TruncateStringProps): string {
  if (str.length <= number) return str;
  return str.slice(0, number) + '...';
}

export function truncateWords({ str, number = 3 }: TruncateStringProps): string {
  const words = str.trim().split(/\s+/);
  if (words.length <= number) return str;
  return words.slice(0, number).join(' ') + '...';
}
